import FileDownloadIcon from "@mui/icons-material/FileDownload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import PaperCustomized from "../../../common/components/PaperCustomized";
import TableCustomized from "../../../common/components/TableCustomized";
import { formattedDateFromDB } from "../../../common/utils/FunctionsUtils";
import { downloadTiDocument } from "../state/TiActions";

function ListDocuments(props) {
  const dispatch = useDispatch();

  const columns = [
    {
      field: "date",
      headerName: "Date",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "description",
      headerName: "Description",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "nom",
      headerName: "Nom du fichier",
      flex: 2,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "type",
      headerName: "Type document",
      flex: 0.75,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "show",
      headerName: "",
      minWidth: 45,
      maxWidth: 45,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <IconButton
          onClick={() => handleShowClick(params)}
          aria-label="View"
          size="small"
          edge="start"
          sx={{ color: "primary.main" }}
        >
          <VisibilityIcon />
        </IconButton>
      ),
    },
    {
      field: "download",
      headerName: "",
      minWidth: 45,
      maxWidth: 45,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <IconButton
          onClick={() => handleDownloadClick(params)}
          aria-label="Download"
          size="small"
          edge="start"
          sx={{ color: "primary.main" }}
        >
          <FileDownloadIcon />
        </IconButton>
      ),
    },
  ];

  const rows = [];
  props?.detail?.document?.map((row, index) => {
    rows.push({
      id: row.id,
      date: formattedDateFromDB(row.date),
      description: row.description,
      nom: row.nomFicher,
      type: row.typeDocument?.description,
      guId: row.guId,
      parentId: row.parentId,
    });
  });

  const handleDownloadClick = (params) => {
    let guId = params.row?.guId;
    let nomFichier = params.row?.nom;
    let parentId = params.row?.parentId;
    dispatch(
      downloadTiDocument(
        guId ? guId : encodeURIComponent(nomFichier),
        parentId,
        "DOWNLOAD"
      )
    );
  };

  const handleShowClick = (params) => {
    let guId = params.row?.guId;
    let nomFichier = params.row?.nom;
    let parentId = params.row?.parentId;
    dispatch(
      downloadTiDocument(
        guId ? guId : encodeURIComponent(nomFichier),
        parentId,
        "SHOW"
      )
    );
  };

  return (
    <PaperCustomized title={"Documents"} forActions={false}>
      <TableCustomized
        columns={columns}
        rows={rows}
        totalElements={rows.length}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationMode="client"
        isSlots={false}
        isFooter={true}
        noDataHeight="120px"
        cursor="auto"
      />
    </PaperCustomized>
  );
}

export default ListDocuments;
